const holder = {
  closePageSizeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isDropdownOpen', false);
      document.removeEventListener('mousedown', holder.closePageSizeSelector);
    }
  }
};

export default {
  'TableFooter.Navigator.FirstPage': (state, outlet, internalStateSetter) => {
    internalStateSetter({ pageNumber: 0 });
    outlet({ ...state, pageNumber: 0 });
  },
  'TableFooter.Navigator.PrevPage': (state, outlet, internalStateSetter) => {
    if (state.pageNumber > 0) {
      internalStateSetter({ pageNumber: state.pageNumber - 1 });
      outlet({ ...state, pageNumber: state.pageNumber - 1 });
    }
  },
  'TableFooter.Navigator.PageNumber': (state, outlet, internalStateSetter) => {
    internalStateSetter({ pageNumber: state.pageNumber + state.option });
    outlet({ ...state, pageNumber: state.pageNumber + state.option });
  },
  'TableFooter.Navigator.NextPage': (state, outlet, internalStateSetter) => {
    internalStateSetter({ pageNumber: state.pageNumber + 1 });
    outlet({ ...state, pageNumber: state.pageNumber + 1 });
  },
  'TableFooter.Navigator.LastPage': (state, outlet, internalStateSetter) => {
    const lastPage = Math.ceil(state.total / state.pageSize);
    internalStateSetter({ pageNumber: lastPage - 1 });
    outlet({ ...state, pageNumber: lastPage - 1 });
  },
  'TableFooter.PageSizeSelector.Dropdown.Header': ({ isDropdownOpen, dropdownRef }, stateManager, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = dropdownRef;
    internalStateSetter('isDropdownOpen', !isDropdownOpen);
    if (isDropdownOpen) {
      document.removeEventListener('mousedown', holder.closePageSizeSelector);
    } else {
      document.addEventListener('mousedown', holder.closePageSizeSelector);
    }
  },
  'TableFooter.PageSizeSelector.Dropdown.Body.PageSize': (state, outlet, internalStateSetter) => {
    internalStateSetter({ pageSize: state.option, isDropdownOpen: false });
    outlet({ ...state, pageSize: state.option, pageNumber:0 });
  }
};
